import React from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import { MakeCurveLine, MakeMap, MakeMarker } from './utils';

mapboxgl.accessToken =
  'pk.eyJ1IjoiZW52aW9pZCIsImEiOiJja3g0bWx5NjgwN3MwMm9wYXB0cnpxdm43In0.F4GEDaOI0_o6fwWkL2r0lQ';

const Maps = ({ log, className }) => {
  const mapContainer = React.useRef(null);
  const map = React.useRef(null);

  const [routeID, setRouteID] = React.useState([]);

  React.useEffect(() => {
    if (map?.current) return;

    map.current = new mapboxgl.Map(MakeMap(mapContainer?.current));
  });

  const reset = () => {
    routeID?.forEach((route) => {
      const layer = map.current.getLayer(route);
      const source = map.current.getSource(route);

      if (typeof layer !== 'undefined') {
        map.current.removeLayer(route);
      }

      if (typeof source !== 'undefined') {
        map.current.removeSource(route);
      }
    });

    setRouteID([]);
  };

  const $reset = (key) => {
    const layer = map.current.getLayer(key);
    const source = map.current.getSource(key);
    if (typeof layer !== 'undefined') {
      map.current.removeLayer(key);
    }

    if (typeof source !== 'undefined') {
      map.current.removeSource(key);
    }
  };

  const makeLine = (curved, i) => {
    const key = `route-log-${i}`;

    $reset(key);

    map?.current?.addSource(key, {
      type: 'geojson',
      data: curved,
    });

    map?.current?.addLayer({
      id: key,
      source: key,
      type: 'line',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': 1,
        'line-color': '#848484',
        'line-dasharray': [3, 3, 3],
      },
    });
  };

  const setPoint = () => {
    let prevLoc = null;
    const bounds = new mapboxgl.LngLatBounds();
    log?.forEach((loc, i) => {
      if (loc?.latitude !== 0 && loc?.longitude !== 0) {
        const point = [loc?.longitude, loc?.latitude];

        MakeMarker(point, '', '', '#2f83ba', i === 0).addTo(map?.current);

        bounds.extend(point);

        if (prevLoc) {
          makeLine(MakeCurveLine(prevLoc, point), i);
          prevLoc = point;
        } else {
          prevLoc = point;
        }
      }
    });

    if (bounds?._ne && bounds?._sw) {
      map?.current.fitBounds(bounds, {
        padding: 50,
        maxZoom: 10,
      });
    }
  };

  React.useEffect(() => {
    if (!map?.current) return;
    if (!log) return;

    reset();
    map?.current.on('load', () => {
      setPoint();
    });
  }, [log]);

  return (
    <div>
      <div className="position-relative">
        <div
          ref={mapContainer}
          className={className ? className : 'map-container rounded-3'}
        />
      </div>
    </div>
  );
};

export default Maps;
